export default "__VITE_ASSET__DwY7RG7R__"